export const LOG_IN = 'LOG_IN';
export const SET_USER = 'SET_USER';
export const LOG_OUT = 'LOG_OUT';
export const SET_SITE = 'SET_SITE';
export const SET_AZIMUT = 'SET_AZIMUT';
export const SET_AGENCE_ID = 'agenceId';
export const SET_IS_USER_AFFIXE2 = 'SET_IS_USER_AFFIXE2';
export const SET_USERS = 'SET_USERS';



// WEBPACK FOOTER //
// ./src/store/modules/user-mutation-type.js